"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Text, useMultiStyleConfig, useBreakpointValue, } from "@chakra-ui/react";
import { Variants } from "./ErrorPage.types";
import { XmarkVariant } from "./XmarkVariant";
import { BackgroundVariant } from "./BackgroundVariant";
import { Illustration, XMark } from "../../atoms";
import { PROD_CDN_BASE_URL } from "../../helpers";
import { getErrorIcon, getXmarkSize } from "./helpers";
const ErrorPage = ({ children, titleIcon, titleLabel, errorCode, errorIcon, errorMessage, variant = Variants.DEFAULT, colorTheme, }) => {
    const size = useBreakpointValue({
        sm: "sm",
        md: "md",
        lg: "lg",
    }, {
        fallback: "md",
    });
    const styles = useMultiStyleConfig("ErrorPage", {
        errorCode,
        size,
        titleLabel,
        variant,
    });
    const illustrationSize = getErrorIcon(size);
    if (variant === Variants.XMARK_VARIANT) {
        return (_jsx(XmarkVariant, { titleLabel: titleLabel, errorMessage: errorMessage, variant: variant }));
    }
    if (variant === Variants.BG_VARIANT) {
        return (_jsx(BackgroundVariant, { titleLabel: titleLabel, errorMessage: errorMessage, variant: variant, colorTheme: colorTheme }));
    }
    return (_jsxs(Box, Object.assign({ sx: styles.mainContainer, className: "error-page-container" }, { children: [_jsxs(Flex, Object.assign({ flexDirection: "column", alignItems: "center", className: "error-page-description" }, { children: [_jsxs(Flex, Object.assign({ className: "error-page-title", alignItems: "center", sx: styles.errorTitle }, { children: [titleIcon && (_jsx(XMark, { width: getXmarkSize(size), variant: titleIcon })), _jsx(Text, Object.assign({ sx: styles.errorTitleText }, { children: titleLabel }))] })), errorIcon && (_jsx(Box, Object.assign({ className: "error-page-logo", sx: styles.errorLogo }, { children: _jsx(Illustration, Object.assign({}, illustrationSize, { illustrationId: errorIcon, cdnUrl: `${PROD_CDN_BASE_URL}/illustrations/`, alt: "Not found illustration" })) }))), _jsx(Flex, Object.assign({ className: "error-page-footer", sx: styles.errorFooter }, { children: _jsx(Text, Object.assign({ as: "span" }, { children: errorMessage })) }))] })), children] })));
};
ErrorPage.displayName = "ErrorPage";
export default ErrorPage;
//# sourceMappingURL=ErrorPage.js.map